(function () {
  const PRINT_PAGE_URL = "/pages/estimate-print";
  const STORAGE_KEY = "estimate_print_payload_v1";

  function qs(sel, ctx = document) {
    return ctx.querySelector(sel);
  }

  function pad2(n) {
    return String(n).padStart(2, "0");
  }

  function makeEstimateNo(d) {
    return `${d.getFullYear()}${pad2(d.getMonth() + 1)}${pad2(d.getDate())}_${pad2(
      d.getHours()
    )}${pad2(d.getMinutes())}${pad2(d.getSeconds())}`;
  }

  function makeIssueDate(d) {
    return `${d.getFullYear()}年${pad2(d.getMonth() + 1)}月${pad2(d.getDate())}日`;
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function formatMoney(cents) {
    const moneyFormat =
      (window.theme && window.theme.money_format) ||
      (window.Shopify && window.Shopify.money_format) ||
      "{{amount}}";

    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return (cents / 100).toLocaleString();
  }

  const MSG = {
    LOAD_FAIL: "お見積書データを読み込めませんでした。",
    MODAL_NOT_FOUND: "お見積書モーダルが見つかりませんでした。",
  };

  async function loadCartAndFill(modal) {
    const issueDateEl = qs("#EstimateIssueDate", modal);
    const noEl = qs("#EstimateNo", modal);
    const nameInput = qs("#EstimateName", modal);

    const itemsTbody = qs("#EstimateItems", modal);
    const totalTop = qs("#EstimateTotalTop", modal);
    const totalBottom = qs("#EstimateTotalBottom", modal);

    if (!itemsTbody || !totalTop || !totalBottom) return;

    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("cart.js fetch failed");
    const cart = await res.json();

    const now = new Date();
    if (issueDateEl) issueDateEl.textContent = makeIssueDate(now);
    if (noEl) noEl.textContent = makeEstimateNo(now);

    const customerName = (modal.dataset.customerName || "").trim();
    if (nameInput && nameInput.dataset.defaultFilled !== "true") {
      if (customerName) {
        nameInput.value = `${customerName} 様`;
      } else if (!nameInput.value.includes("様")) {
        nameInput.value = " 様";
      }

      nameInput.dataset.defaultFilled = "true";
      nameInput.setAttribute("value", nameInput.value);
    }

    itemsTbody.innerHTML = "";

    cart.items.forEach((item) => {
      const tr = document.createElement("tr");

      const tdName = document.createElement("td");
      tdName.className = "invoice-goodsName";
      tdName.innerHTML = `
        ${escapeHtml(item.product_title)}
        ${item.variant_title ? `<br><small>${escapeHtml(item.variant_title)}</small>` : ""}
      `;

      const tdQty = document.createElement("td");
      tdQty.textContent = item.quantity;

      const tdPrice = document.createElement("td");
      tdPrice.className = "total_price_td";
      tdPrice.textContent = formatMoney(item.final_line_price);

      tr.appendChild(tdName);
      tr.appendChild(tdQty);
      tr.appendChild(tdPrice);

      itemsTbody.appendChild(tr);
    });

    const totalText = formatMoney(cart.total_price);
    totalTop.textContent = totalText;
    totalBottom.textContent = totalText;
  }

  function openModal(modal) {
    modal.hidden = false;
    modal.removeAttribute("hidden");
    document.body.classList.add("estimate-modal-open");
  }

  function closeModal(modal) {
    modal.hidden = true;
    modal.setAttribute("hidden", "");
    document.body.classList.remove("estimate-modal-open");
  }

  function buildPrintableHtml(modal) {
    const nameInput = qs("#EstimateName", modal);
    if (nameInput) {
      nameInput.setAttribute("value", nameInput.value);
    }

    const clone = modal.cloneNode(true);
    clone.hidden = false;
    clone.removeAttribute("hidden");

    return clone.outerHTML;
  }

  async function goPrintPage(modal) {
    if (!modal) {
      alert(MSG.MODAL_NOT_FOUND);
      return;
    }

    try {
      await loadCartAndFill(modal);
    } catch (err) {
      console.error(err);
      alert(MSG.LOAD_FAIL);
      return;
    }

    openModal(modal);

    const html = buildPrintableHtml(modal);

    const payload = {
      html,
      returnUrl: location.href.split("#")[0],
      createdAt: Date.now(),
    };

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {
      console.error(e);
      alert("印刷データの保存に失敗しました。");
      return;
    }

    location.href = PRINT_PAGE_URL + "?ts=" + Date.now();
  }

  function init() {
    document.addEventListener("click", async (e) => {
      const openBtn = e.target.closest("#OpenEstimate, [data-open-estimate]");
      if (openBtn) {
        e.preventDefault();

        const modal = document.getElementById("EstimateModal");
        if (!modal) {
          alert(MSG.MODAL_NOT_FOUND);
          return;
        }

        openModal(modal);

        try {
          await loadCartAndFill(modal);
        } catch (err) {
          console.error(err);
          alert(MSG.LOAD_FAIL);
        }
        return;
      }

      const closeBtn = e.target.closest("[data-close-estimate]");
      if (closeBtn) {
        const modal = document.getElementById("EstimateModal");
        if (modal && !modal.hidden) {
          e.preventDefault();
          closeModal(modal);
        }
        return;
      }

      const printBtn = e.target.closest("#EstimatePrintBtn");
      if (printBtn) {
        e.preventDefault();

        const modal = document.getElementById("EstimateModal");
        await goPrintPage(modal);
        return;
      }
    });

    window.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        const modal = document.getElementById("EstimateModal");
        if (modal && !modal.hidden) closeModal(modal);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
